import _ from 'lodash';
import { createContext, useContext } from 'react';

export interface IAnimatedViewContext<T> {
  back: () => void;
  current: T;
  push: (view: T) => void;
}

const createAnimatedViewContext = <T>() =>
  createContext<IAnimatedViewContext<T>>({
    back: _.noop,
    current: undefined,
    push: _.noop,
  });

export const AnimatedViewContext = createAnimatedViewContext();

export const useAnimatedViewContext = <T>() =>
  useContext(AnimatedViewContext) as IAnimatedViewContext<T>;
